export default [
  {
    name: 'user-register',
    path: '/users/register/create',
    component: () => import('@/views/users/register/UserRegisterManage')
  },
  {
    name: 'user-register-complete',
    path: '/users/register/complete',
    component: () => import('@/views/users/UserManage')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUserRegistration.js